export function AudioWorklet(url) {
  return url;
}
